import { PageTitle } from '../elements/atoms/pageTitle/PageTitle';
import { Paragraph } from '../elements/atoms/paragraph/Paragraph';
import { ParagraphTitle } from '../elements/atoms/paragraphTitle/ParagraphTitle';
import { Article } from '../elements/molecules/article/article';
import { Container } from '../elements/molecules/container/Container';
import { Main } from '../elements/molecules/main/Main';
import { PageSection } from '../elements/molecules/pageSection/PageSection';
import { Footer } from '../elements/organisms/footer/Footer';
import { Header } from '../elements/organisms/header/Header';
import { PageWrapper } from '../elements/organisms/pageWrapper/PageWrapper';

export function Contact() {
    return (
        <PageWrapper fullHeight={true}>
            <Header hasBackbutton={true} />
            <Main>
                <Container isFluidOnMobile={true}>
                    <PageSection>
                        <Article>
                            <PageTitle className="m-0">Contact</PageTitle>
                        </Article>
                    </PageSection>
                    <PageSection bgColor="white">
                        <Article>
                            <ParagraphTitle>Ons kantoor</ParagraphTitle>
                            <Paragraph>
                                Willem Fenengastraat 17, 1096 BL Amsterdam <br /> <br />
                                We zijn op werkdagen telefonisch bereikbaar van 08:30 tot 17:00. <br />
                                +31 (0) 20 600 00 60 <br />
                                Per mail zijn wij bereikbaar op: info@ksyos.nl
                            </Paragraph>
                        </Article>
                    </PageSection>
                </Container>
            </Main>
            <Footer />
        </PageWrapper>
    );
}
